import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useDataContext } from '../../contexts/DataContext';
import Patient from '../../models/Patient';

type Props = {
    patient: Patient;
};

const PatientTableRow = ({ patient }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    // const { naPosNeg } = useFormatter(); //Se ha eliminado amyloidPet
    const { currentUserRole } = useDataContext();

    const editPatient = () => {
        navigate(`/patient/${patient.id}`);
    };

    const showEditButton =
        (currentUserRole === 'client' || currentUserRole === 'admin') && patient.probCtrl === null;
    //  ||(currentUserRole === 'neuro' && patient.probCtrl !== null && patient.neuroEval === null); se ha eliminado el rol neurologo

    const buttons = (
        <>
            {showEditButton && (
                <button
                    type="button"
                    onClick={editPatient}
                >
                    {t('button.edit')}
                </button>
            )}
            {patient.categoryId && (
                <Link
                    to={`/patient/report/${patient.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <button type="button">{t('button.report')}</button>
                </Link>
            )}
        </>
    );

    let tdNeuroEval = (
        <td className="td-flex td-patient-pending">
            <div className="truncated">{t('label.waiting_sample')}</div>
            <div>{buttons}</div>
        </td>
    );

    if (patient.probCtrl !== null) {
        tdNeuroEval = (
            <td className="td-flex td-patient-pending">
                <div className="truncated">{t('label.pending')}</div>
                <div>{buttons}</div>
            </td>
        );
    }

    const { i18n } = useTranslation();

    if (patient.categoryId !== null) {
        tdNeuroEval = (
            <td className="td-flex">
                <div className="truncated">
                    {i18n.language === 'es'
                        ? patient.categoryEs
                        : i18n.language === 'en'
                        ? patient.categoryEn
                        : patient.categoryCa}
                </div>
                <div>{buttons}</div>
            </td>
        );
    }

    const format = (prob: number | null) => {
        if (prob === null) return '--';
        return `${(prob * 100).toFixed(1)}%`;
    };

    return (
        <tr>
            {currentUserRole === 'admin' && (
                <>
                    <td>{patient.username || '--'}</td>
                    <td>{patient.userCode || '--'}</td>
                </>
            )}
            <td>{patient.code}</td>
            {/* <td>{sex(patient.sex)}</td> */}
            <td>{patient.age}</td>
            <td>{patient.cdr}</td>
            <td>{patient.sob}</td>
            {/* <td>{patient.mmse !== null ? patient.mmse : '--'}</td> */}
            <td>{patient.apoe === 'add_later' ? t('label.add_later') : patient.apoe}</td>
            {/* <td>{naPosNeg(patient.amyloidPet)}</td> */}
            <td>{format(patient.probCtrl)}</td>
            <td>{format(patient.probMci)}</td>
            <td>{format(patient.probAd)}</td>
            {tdNeuroEval}
        </tr>
    );
};

export default PatientTableRow;
